var React = require('react');

function SvgDecoratorBlob9 (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(300,300)"},React.createElement("path",{"d":"M153.6,-239C199.1,-209.8,236,-167.2,258.4,-118C280.9,-68.9,288.9,-13.1,281.2,40.4C273.5,93.9,250.1,145.2,214.7,186.1C179.3,226.9,131.9,257.4,80,272.6C28.2,287.8,-28.2,287.8,-80,272.6C-131.9,257.4,-179.3,226.9,-214.7,186.1C-250.1,145.2,-273.5,93.9,-281.2,40.4C-288.9,-13.1,-280.9,-68.9,-258.4,-118C-236,-167.2,-199.1,-209.8,-153.6,-239C-108.1,-268.3,-54.1,-284.1,0,-284.1C54.1,-284.1,108.1,-268.3,153.6,-239Z","fill":"currentColor"})));
}

SvgDecoratorBlob9.defaultProps = {"viewBox":"0 0 600 600"};

module.exports = SvgDecoratorBlob9;

SvgDecoratorBlob9.default = SvgDecoratorBlob9;
